// Locale codes mirror the Lokalise project (underscored, region-suffixed).
// Single shared source of truth for both the header and footer language
// selectors — add/remove a language here and both pick it up automatically.
// When adding a new code, also register its resources in ./config.js so
// i18next can resolve it (otherwise it silently falls back to English).
export const LANGUAGES = [
	{ code: "en",          label: "English" },
	{ code: "zh_Hans_HK",  label: "Chinese Simplified - Hong Kong" },
	{ code: "zh_HK",       label: "Chinese Traditional - Hong Kong" },
	{ code: "en_AU",       label: "English - Australia" },
	{ code: "en_CA",       label: "English - Canada" },
	{ code: "en_JP",       label: "English - Japan" },
	{ code: "fr",          label: "French" },
	{ code: "de",          label: "German" },
	{ code: "it",          label: "Italian" },
	{ code: "ja_JP",       label: "Japanese - Japan" },
	{ code: "es",          label: "Spanish" },
]

export const DEFAULT_LOCALE = "en"
export const STORAGE_KEY = "bb_selected_locale"
